import { PauseCircle, PlayCircle } from "lucide-react";

const MockTestPauseTest =({overallTestTime,mockTestCard1Object,setClosePausePopUp,handleStartPause,isRunning})=>{
 
 
  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };
 return(<>
       <div    onClick={()=>setClosePausePopUp(false)} className="mockTestV1PopUpOpacity"  style={{cursor:"pointer"}}> </div>
        <div   className="mockTestV1PopUp" style={{borderRadius: '20px'}}> 
        <h2 align="center" >   <span className="mockTestColoredTextV1" style={{fontSize:"34px"}} >{isRunning?"Pause ":"Resume "} Mock Test</span> </h2>
      
 
<div style={{overflowY:"auto",height:"240px",overflowX:"hidden"}}>
    <div style={{display:"flex",justifyContent:"center"}}>
 {isRunning ? <PauseCircle style={{position:"relative"}}   color={mockTestCard1Object?.pauseBtn?.iconColor?.color} size={60}/>  : <PlayCircle style={{position:"relative"}}   color={mockTestCard1Object?.pauseBtn?.iconColor?.color} size={60}/> }
</div>
<div style={{display:"flex",justifyContent:"center"}}>
<div style={{fontSize:"20px",fontWeight:"999",padding:"5px",background:`${mockTestCard1Object?.quizTimer?.bgColor?.color}`,
    border:` ${mockTestCard1Object?.quizTimer?.border?.borderWidth?.value+mockTestCard1Object?.quizTimer?.border?.borderWidth?.resolution} ${mockTestCard1Object?.quizTimer?.border?.borderType}  ${mockTestCard1Object?.quizTimer?.border?.borderColor?.color}`,
     borderTopLeftRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.topLeft?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.topLeft?.resolution}`,
                  borderTopRightRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.topRight?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.topRight?.resolution}`,
                  borderBottomLeftRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.bottomLeft?.resolution}`,
                  borderBottomRightRadius:`${mockTestCard1Object?.quizTimer?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.quizTimer?.borderRadius?.bottomRight?.resolution}`,
    }}>{mockTestCard1Object?.quizTimer?.theme=="T1"?<span class="coloredTextMockV1 mockTestTitleFont">{formatTime(overallTestTime)}</span> :<span class=" mockTestTitleFont" style={{color:mockTestCard1Object?.quizTimer?.textColor?.color}}>{formatTime(overallTestTime)}</span> } 
          {overallTestTime === 0 && <div className="mockTestTitleFont" style={{ fontSize: '20px', marginTop: '20px' }}>Time's up!</div>}</div>
 
 </div>
 {isRunning ?<div style={{display:"flex",justifyContent:"center",marginTop:"-9px"}}>
    <div style={{textAlign:"center"}}>
 <p>Are You Sure you want to pause this test?</p>
 <p>Your progress will be saved & you can resume test later too.</p>
 </div>
 </div>:<div style={{display:"flex",justifyContent:"center"}}>
    <div style={{textAlign:"center"}}>
 
 <p>Test will be resumed from where you left previously.</p>
 </div>
 </div>}
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"10px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button  onClick={()=>setClosePausePopUp(false)}    className=" MocktestPausePlayBtn"  type="submit"
 > Cancel </button>
 {isRunning?
<button  onClick={()=>{handleStartPause();}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestPausePlayBtn"  type="submit"
 > Pause Test </button>:<button  onClick={()=>{handleStartPause();}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestPausePlayBtn"  type="submit"
 > Resume Test </button>}
</div> 
</div></div>
<style>{`
.MocktestPausePlayBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1 {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.mockTestV1PopUpOpacity{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.061);
        z-index:9999999999 !important}
        
        .mockTestV1PopUp{position:fixed;top:0px;
    left:30%;
    right:30%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:22%;
    padding:15px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
    .mockTestV1PopUp{position:fixed;top:0px;
        left:20%;
        right:20%;top:22%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
  .mockTestV1PopUp{position:fixed;top:0px;
                left:20%;
                right:20%;top:22%;
               }} 

/* xs */
@media (max-width: 767px) {
    
    .mockTestV1PopUp{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style>
    </>)
}
export default MockTestPauseTest;